<template>
  <v-row class="justify-center" transition="slide-x-transition">
    <v-col cols="12" sm="10" md="8" lg="6" class="d-flex align-stretch pa-1">
      <v-card class="flex-grow-1">
        <v-tabs v-model="tab" background-color="grey lighten-4" class="elevation-0" light :right="false"
          :icons-and-text="true">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-financial">
            Relatório financeiro
            <v-icon>fa-solid fa-wallet</v-icon>
          </v-tab>
          <v-tab href="#tab-coparticipacao" v-if="hasCoparticipation()">
            Co-participação
            <v-icon>fal fa-usd-square</v-icon>
          </v-tab>
          <v-tab href="#tab-irpf" @click="verifyIRPF">
            IRPF
            <v-icon>fa-solid fa-circle-info</v-icon>
          </v-tab>
          <v-spacer></v-spacer>
          <v-btn icon @click="$router.go(-1)" class="mt-4 mr-4">
            <v-icon>fa-solid fa-reply</v-icon>
          </v-btn>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-irpf" max-height="300px">
            <v-card flat tile>
              <!-- <v-card-title>
                // v-for="paymentsList in plans" v-bind:key="paymentsList.contrato.id"
                {{paymentsList.contrato.plano }}
              </v-card-title> -->
              <v-card-text style="min-height: 300px;">
                <irpf :irpfMessage="irpfMessage" :allIrpfReports="allIrpfReports" />
              </v-card-text>
            </v-card>
            <v-card flat tile>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-financial" style="max-height: 60vh; overflow: scroll">
            <v-card flat tile v-for="paymentsList in plans" v-bind:key="paymentsList.contrato.id">
              <v-card-title>
                {{ paymentsList.contrato.plano }}
              </v-card-title>
              <v-card-text>
                <payments :allPayments="onlyPaid(paymentsList.fichafinanceira)" />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-coparticipacao" style="max-height: 60vh; overflow: scroll">
            <v-card flat tile v-for="(plansList, index) in plans" v-bind:key="index">
              <v-card-title>
                {{ plansList.contrato.plano }}
              </v-card-title>
              <v-card-text>
                <coparticipation :allPayments='plansList.coparticipacao' />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import coparticipation from './coparticipation'
import irpf from './irpf'
import payments from './payments'

export default {
  components: {
    coparticipation,
    irpf,
    payments
  },
  data() {
    return {
      tab: 'tab-financial',
    }
  },
  watch: {
    plans: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal.length) {
          let _this = this
          this.$store.dispatch('irpf/getIrpfReportsList', this.plans[0], { root: true })
        }
      }
    }
  },
  computed: {
    plans() {
      return this.$store.state.plans.plans
    },
    userName() {
      return this.$store.state.plans.userName
    },
    allIrpfReports() {
      return this.$store.state.irpf.allIrpfReports
    },
    irpfMessage() {
      return this.$store.state.irpf.irpfMessage
    }
  },
  methods: {
    onlyPaid(paymentslist) {
      let allPayments = paymentslist.filter(payment => payment.situacao == 'Pago')
      return allPayments
    },
    hasCoparticipation() {
      var coparticipationPlan = this.plans.find(plan => plan.contrato.coparticipacao == "sim")
      return (coparticipationPlan) ? true : false;
    },
    verifyIRPF() {
      console.log('mmm')
      if (this.allIrpfReports == [] && this.message == '') {
        this.$store.dispatch('irpf/getIrpfReportsList', planos[0], { root: true })
      }

    }
  }
}
</script>

<style></style>